import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";

const AuthContext = createContext();
export const useAuth0Context = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({ name: "", email: "" });
  const [token, setToken] = useState("");
  const [isAuthenticate, setIsAuthenticate] = useState(false);
  const [isCalled, setIsCalled] = useState(false);
  const navigate = useNavigate();

  const initAuth = async () => {
    try {
      const newToken = await authService.checkAndRefreshToken();
      if (!newToken) {
        throw new Error("Token missing or refresh failed.");
      }

      const decoded = authService.parseToken(newToken);
      if (!decoded || !decoded.email) {
        throw new Error("Failed to decode token or missing required fields.");
      }

      setUser(decoded);
      setToken(newToken);
      setIsAuthenticate(true);
    } catch (error) {
      resetAuthState(authService.logout());
    } finally {
      setIsCalled(true);
    }
  };

  const resetAuthState = (navigateTo = "/") => {
    setUser({ name: "", email: "" });
    setToken("");
    setIsAuthenticate(false);
    authService.removeToken();
    navigate(navigateTo);
  };

  useEffect(() => {
    initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isAuthenticate) {
      authService.startRefreshTimer(initAuth);
    } else {
      authService.stopRefreshTimer();
    }
    return () => authService.stopRefreshTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticate]);

  useEffect(() => {
    const handleVisibility = async () => {
      if (!document.hidden) {
        authService.startRefreshTimer(initAuth);
        await initAuth();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticate, setUser, setToken, setIsAuthenticate, resetAuthState }}>
      {isCalled && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
